import { Reducer } from 'redux';
import { types } from './ConfirmationActions';
import { IConfirmationAction, IConfirmationState } from './ConfirmationModel';

export const confirmationReducer: Reducer<IConfirmationState, IConfirmationAction> = (
    state: IConfirmationState = {},
    action: IConfirmationAction,
) => {
    switch (action.type) {
        case types.DISPLAY_CONFIRMATION_MESSAGE: {
            return {
                ...state,
                title: action.title,
                message: action.message,
                type: action.type,
                confirmationType: action.confirmationType,
                param1: action.param1,
                visible: true,
            };
        }

        case types.HANDLE_CONFIRMATION_CLOSE: {
            return {
                ...state,
                title: '',
                message: '',
                type: '',
                confirmationType: '',
                visible: false,
                param1: '',
            };
        }

        default:
            return state;
    }
};
